import Lookup from 'src/componentes/select2';

const TipoFiltroData = ({ clearable = false, ...rest }) => (
  <Lookup
    clearable={clearable}
    labelKey="descricao"
    valueKey="id"
    url="/TipoFiltroDataLookup"
    {...rest}
  />
);

export default TipoFiltroData;
